
<div class="m-subheader" appunwraptag="">
  <div class="d-flex align-items-center">
    <div class="mr-auto">

      <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
          <li class="m-nav__item m-nav__item--home">
             <h3 class="breadCrumb-label">{{breadCrumbLabel}}</h3>
            </li>
            <h3 class="m-subheader__title m-subheader__title--separator">
        
              </h3>
        <li class="m-nav__item m-nav__item--home">
          <a  class="m-nav__link m-nav__link--icon">
            <i class="m-nav__link-icon la la-home"></i>
          </a>
        </li>
         <li class="m-nav__separator">
          -
        </li>
        <li  class="m-nav__item">
          <a (click)="goToDashboard()" class="m-nav__link" style="cursor:pointer">
            <span class="m-nav__link-text">
              Dashboard
            </span>
          </a>
        </li>
        <li *ngFor="let breadcrumb of breadcrumbs" class="m-nav__item">
          <a (click)="navigate(breadcrumb)" style="cursor:pointer" class="m-nav__link">
            <span class="m-nav__link-text">
              <span class="m-nav__separator">-</span> {{breadcrumb.label}}
            </span>
          </a>
        </li>
        <!-- <li class="m-nav__separator">
          -
        </li>
        <li class="m-nav__item">
          <a href="" class="m-nav__link">
            <span class="m-nav__link-text">
              Typography
            </span>
          </a>
        </li> -->
      </ul>
    </div>
    <div>
    </div>
  </div>
</div>